import * as React from 'react';
import * as styles from './footer.module.scss';

import { Link } from 'gatsby';
import Logo from '../logo';

export default function Footer(props) {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className="row">
          <div className="col-md-7 offset-md-1 order-md-2">
            <div className="row">
              <div className="col-md-4">
                <p className={styles.footerHeading}>Product</p>
                <ul>
                  <li>
                    <Link to="/quizzes/">Quiz Gallery</Link>
                  </li>
                  <li>
                    <Link to="/integrations/">Integrations</Link>
                  </li>
                  <li>
                    <Link to="/examples/">Live Examples</Link>
                  </li>
                  <li>
                    <a href="/blog/category/case-studies/">Case Studies</a>
                  </li>
                  <li>
                    <Link to="/plans/">Pricing</Link>
                  </li>
                  <li>
                    <Link to="/plus/">Interact Plus</Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <p className={styles.footerHeading}>Learn</p>
                <ul>
                  <li>
                    <a href="/blog/">Blog</a>
                  </li>
                  <li>
                    <a href="/podcast/">Podcast</a>
                  </li>
                  <li>
                    <a href="https://help.tryinteract.com">Help Center</a>
                  </li>
                  <li>
                    <a href="/blog/">Tutorials</a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@tryinteract">Youtube Videos</a>
                  </li>
                </ul>
                <p className={styles.footerHeading}>Community</p>
                <ul>
                  <li>
                    <Link to="/about/">About Us</Link>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/tryinteract"
                      target="_blank"
                      rel="noopener noreferrer nofollow">
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/tryinteract"
                      target="_blank"
                      rel="noopener noreferrer nofollow">
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.g2crowd.com/products/the-quiz-collective-interact/reviews"
                      target="_blank"
                      rel="noopener noreferrer nofollow">
                      Customer Reviews
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <p className={styles.footerHeading}>Tutorials</p>
                <ul>
                  <li>
                    <a href="/blog/how-to-make-a-buzzfeed-style-quiz/">Make a Buzzfeed Quiz</a>
                  </li>
                  <li>
                    <a href="/blog/how-to-make-a-personality-quiz/">Make a Personality Quiz</a>
                  </li>
                  <li>
                    <a href="/blog/how-to-make-a-multiple-choice-quiz/">
                      Make a Multiple Choice Quiz
                    </a>
                  </li>
                </ul>
                <p className={styles.footerHeading}>Dashboard</p>
                <ul>
                  <li>
                    <a href={`${process.env.GATSBY_DASHBOARD_URL}/login`}>Login</a>
                  </li>
                  <li>
                    <a
                      href="https://status.tryinteract.com"
                      target="_blank"
                      rel="noopener noreferrer nofollow">
                      System Status
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 order-md-1">
            <div>
              <div
                className={styles.footerHeading}
                style={{
                  display: `flex`,
                  flexDirection: 'column',
                  alignItems: 'start',
                  flexWrap: `wrap`,
                }}>
                <span className={styles.tag}>Featured</span>
                <a href="https://ai.tryinteract.com/create">Make A Quiz With AI</a>
              </div>
              <p className={styles.footerContent}>
                Quickly build a unique, high quality quiz to promote your business and generate
                qualified leads.
              </p>
            </div>
            <div className={styles.companyInfo}>
              <div style={{ width: `100px`, height: `24px`, marginBottom: `1rem` }}>
                <Link to="/">
                  <Logo color="#000000" />
                </Link>
              </div>
              <p>Copyright &copy; 2025 The Quiz Collective, Inc.</p>
              <p>
                <Link to="/terms/">Terms of Use</Link>
                <span className={styles.spacer}>&bull;</span>
                <Link to="/privacy/">Privacy Policy</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
